export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "createdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        category: [],
        tableSearch: "",
        collection : null,
    }),
    mutations: {
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_CATEGORY (state, payload) {
            let exists = state.category.find(x => x.collection == state.collection);
            if (exists)
            {
                exists.value = payload;
            }
            else
            {
                state.category.push({collection: state.collection, value: payload});
            }
        },
        SET_TABLE_SEARCH (state, payload) {
            state.tableSearch = payload;
        },
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        getCategory: (s) =>  { 
            let exists = s.category.find(x => x.collection == s.collection);
            if (exists)
            {
                return exists.value;
            }
            else
            {
                switch (s.collection) {
                    case "NewProjects":
                        return "1"
                    case "InWorkProjects":
                        return "2"
                    case "ClosedProjects":
                        return "5"
                    default:
                        return "0"
                }
            }
        },
        getTableSearch: (s) => s.tableSearch,
        getCollection: (s) => s.collection,
    }
}